export default function AtmosphereSection() {
  return (
    <section className="py-20 md:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          {/* Images collage */}
          <div className="w-full lg:w-[45%] flex flex-col gap-4">
            <div className="w-full h-64 md:h-72 rounded-2xl overflow-hidden">
              <img
                src="/img/atmosphere-main.jpg"
                alt="Стендап на конференции"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex gap-4">
              <div className="w-1/2 h-44 rounded-2xl overflow-hidden">
                <img
                  src="/img/atmosphere-lounge.png"
                  alt="Кулуары"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-1/2 h-44 rounded-2xl overflow-hidden">
                <img
                  src="/img/atmosphere-neva.png"
                  alt="Нева"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Text content */}
          <div className="w-full lg:w-[55%]">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0f3d32] mb-8 leading-tight">
              Союз медицины и юмора<br />в Санкт-Петербурге
            </h2>

            <div className="space-y-5 text-gray-600 text-base md:text-lg leading-relaxed mb-10">
              <p>
                Между секциями — 15-минутный стендап «Смехосоматика»: комики превращают врачебный быт в комедию. Это не развлечение — это профилактика выгорания.
              </p>
              <p>
                В обед — AI-болит: протестируйте рекомендации, обсудите с коллегами, задайте вопросы чат-боту. Технологии как партнёр врача.
              </p>
              <p>
                Вечером — прогулка: Лавра в 5 минутах, Нева, Невский рядом. Санкт-Петербург сам по себе — культурная программа.
              </p>
            </div>

            {/* Quote */}
            <div className="border-l-4 border-[#c8963e] pl-6">
              <p className="text-lg md:text-xl text-[#0f3d32] italic leading-relaxed mb-4">
                «Когда смеётесь над профессией — выгорание отступает. Когда говорите честно — растёт уверенность. NeuroRussia — про оба момента.»
              </p>
              <p className="text-gray-500 text-sm font-medium">— проф. Искра Д.А., научный руководитель конференции</p>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 mt-10">
              {[
                { num: '20+', label: 'спикеров' },
                { num: '5', label: 'стендап-пауз' },
                { num: '2', label: 'дня диалогов' },
                { num: '0 ₽', label: 'регистрация' },
              ].map((s) => (
                <div key={s.label}>
                  <div className="text-3xl font-extrabold text-[#1a6b5a]">{s.num}</div>
                  <div className="text-sm text-gray-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
